/*
 *   File : external-import-file-upload.js
 *   Author URI : https://evoqins.com
 *   Description : External import file upload modal
 *   Version : v1.0
 */

import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Icon from "../Icon/icon";

import style from "../../Styles/Components/external-import-file-upload.module.scss";
import QrScanner from "qr-scanner";


import CustomFilePicker from "../FormElements/file-upload";
import { _uploadDocumentToS3 } from "../../Services/aws-service";
import { _isFileTypeAllowed } from "../../Helper/helper-function";
import APIService from "../../Services/api-service";
import { Modal } from "bootstrap";

const ExternalImportFileUploadModal = (props) => {

    const [uploadFileError, setUploadFileError] = useState("");
    const [fileLoader, setFileLoader] = useState(false);

    /* ---------- modal close hook (same as import-external-fund) ---------- */
    useEffect(() => {
        const my_modal = document.getElementById("external-import-file-upload");
        if (!my_modal) return;

        const handleClose = () => props.close();

        my_modal.addEventListener("hidden.bs.modal", handleClose);

        return () => {
            my_modal.removeEventListener("hidden.bs.modal", handleClose);
        };
    }, [props.close]);


    // import { useEffect } from "react";
    // import { Modal } from "bootstrap";

    useEffect(() => {
        const modalEl = document.getElementById("external-import-file-upload");
        if (!modalEl) return;

        const modal = Modal.getOrCreateInstance(modalEl, {
            backdrop: true,
            keyboard: false
        });

        modal.show();

        return () => {
            modal.hide();
        };
    }, []);




    /* ---------- file select ---------- */
    const _handleFileUpload = (value, file) => {
        setUploadFileError("");
        const fileName = value
            .replace(/^.*[\\\/]/, "")
            .replace(/[\(\)\s]/g, "_");

        const parts = fileName.split(".");
        if (parts.length <= 1) {
            setUploadFileError("No file extension found");
            return;
        }

        const extension = "." + parts.pop();

        if (!_isFileTypeAllowed(extension, [".jpeg", ".jpg", ".png"])) {
            setUploadFileError("File type should be .jpeg, .jpg or .png");
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            setUploadFileError("File size should be less than 2MB");
            return;
        }

        _uploadViaAPI(fileName, file);
    };

    /* ---------- upload logic ---------- */
    const _commonUpload = (service, key, file) => {
        setUploadFileError("");
        setFileLoader(true);

        service(true, "general/file-upload", { key: `mandate/${key}` })
            .then((response) => {
                if (response.status_code !== 200) {
                    toast.dismiss();
                    toast.error(response.message);
                    setFileLoader(false);
                    return;
                }

                _uploadDocumentToS3(response.data, key, file)
                    .then(async () => {
                        try {
                            const result = await QrScanner.scanImage(file, {
                                returnDetailedScanResult: true
                            });

                            const parsedQrData =
                                typeof result.data === 'string'
                                    ? JSON.parse(result.data)
                                    : result.data;

                            props.onUploadSuccess?.({
                                qrText: parsedQrData,
                                fileUrl: response.data.view_info
                            });

                            console.log('reqId', parsedQrData.reqId);
                            console.log('clientRefNo', parsedQrData.clientRefNo);


                            const modalEl = document.getElementById("external-import-file-upload");
                            const modalInstance = Modal.getInstance(modalEl);
                            if (modalInstance) modalInstance.hide();

                        } catch (err) {
                            toast.dismiss();
                            toast.error("Unable to read QR code from image");
                        } finally {
                            setFileLoader(false);
                        }
                    })
                    .catch(() => {
                        toast.dismiss();
                        toast.error("Upload failed");
                        setFileLoader(false);
                    });
            });
    };


    const _uploadViaAPI = (key, file) => {
        _commonUpload(APIService, key, file);
    };




    return (
        <div
            className={`modal fade ${style.e_upload_signature_modal}`}
            id="external-import-file-upload"
            tabIndex="-1"
            aria-hidden="true"
            data-bs-backdrop="true"
        >
            <div className={`modal-dialog modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content padding-32px-all position-relative ${style.e_content}`}>

                    {/* close icon – same pattern */}
                    <Icon
                        icon="close"
                        size={24}
                        className={`position-absolute  cursor-pointer e-modal-close-btn top-24px right-20px  `}
                        data-bs-dismiss="modal"
                    />

                    <h6 className="e-poppins-semi-bold e-font-18 color-almost-black text-center">
                        Upload downloaded QR code
                    </h6>
                    <p className="e-poppins-regular e-font-14 color-almost-black text-center mb-4">
                        Paste or upload a clear scanned copy (.jpg / .jpeg / .png)
                    </p>

                    <CustomFilePicker
                        accept=".jpeg, .jpg, .png"
                        className="e-select-file"
                        type={2}
                        pastable={true}
                        loading={fileLoader}
                        error={uploadFileError}
                        onSelectFile={(path, file) =>
                            _handleFileUpload(path, file)
                        }
                    />

                </div>
            </div>
        </div>
    );
};

export default ExternalImportFileUploadModal;
